import { Button } from '@cp/ds/src/components/button';
import { BurgerIcon } from '@cp/ds/src/icons/burger';
import React from 'react';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { SxProps } from '@cp/ds';
import { useBurgerMenuController } from '../model';

export interface BurgerMenuProps {
  sx?: SxProps;
}

export const BurgerMenuButton: React.FC<BurgerMenuProps> = ({ sx }) => {
  const burgerMenuController = useBurgerMenuController();

  return (
    <Button color="gray" onClick={burgerMenuController.open} size="small" square sx={mergeSx({}, sx)} variant="text">
      <BurgerIcon />
    </Button>
  );
};
